module.exports = __webpack_public_path__ + "img/CS-UL-HD-Info.ca2ac1b1.jpg";